import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
export const apiContext = createContext()
function Api(props) {
    const API_URL = process.env.REACT_APP_API_URL;
    // const API_URL = 'http://localhost:8000/api';
    const token = localStorage.getItem("token");
    axios.defaults.baseURL = API_URL;
    axios.defaults.headers.common = { 'Authorization': `Bearer ${token}`, 'Accept': 'application/json' }
    return (
        <apiContext.Provider
            value={{
                axios, API_URL
            }}>
            {props.children}
        </apiContext.Provider>
    )
}
export default Api;